<template>
	<div
		id="accordion"
		role="tablist"
		:aria-multiselectable="isMultiple"
		:class="bemm('')"
	>
		<slot></slot>
	</div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';
import { useBemm } from 'bemm';
import type { CollapseValue } from './Collapse.model';
import { useCollapseRoot } from './useCollapse';

const props = defineProps({
	modelValue: {
		type: [String, Number, Array] as PropType<CollapseValue>,
		default: null,
	},
	active: {
		type: [String, Number, Array] as PropType<CollapseValue>,
		default: null,
	},
	animationDuration: {
		type: Number as PropType<number>,
		default: 250,
	},
	multipleActive: {
		type: Boolean as PropType<boolean>,
		default: true,
	},
	accordion: {
		type: Boolean as PropType<boolean>,
		default: false,
	},
	activeIndex: {
		type: Number as PropType<number>,
		default: -1,
	},
});

const emit = defineEmits(['update:modelValue', 'change']);

const bemm = useBemm('ar-collapse', {
	return: 'string',
	includeBaseClass: true,
});

const { isMultiple } = useCollapseRoot(props, emit);
</script>

<style lang="scss">
.ar-collapse {
	display: flex;
	flex-direction: column;
	gap: var(--space-s);
}
</style>
